import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { RootStoreContext } from "../app/stores/rootStore";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import InfoMessage from "../components/common/InfoMessage";
import { Link, useHistory } from "react-router-dom";
import "../assets/scss/tema/buttonLogout.scss";
import {
  Button
} from "reactstrap";
import agent from "../app/api/agent";
const LogOutSSO = () => {

  const alertPrimaryStyle = {
    color: '#fff',
    borderColor: '#5e72e4',
    backgroundColor: '#5e72e4',
  };
  
  const rootStore = useContext(RootStoreContext);
  
  const [t] = useTranslation(["translation"], translationHookOptions);
  const { logout } = rootStore.userStore;
 
 
  const handleHome = async () => {
    await logout("openid");
    window.location.href = '/player/';
  }
  const handleLogout = async () => {
    
    var url= await logout("openid");
    console.log("url="+url)
    if (url!=null){
      window.location.href = url;
    }
    
  }
  useEffect( ()=>{
    async function fetchlogout(){
    const res=await agent.User.logout();
    }
    fetchlogout();
  },[])


  return (
    <>
      <div>
        <InfoMessage style={alertPrimaryStyle}  icon="fas fa-sign-out-alt fa-3x" message={t("logging_out")} />
      </div>

      <div className="text-center alert fade show">

        <Button className="btnlo colMarginTop colMarginTop " style={{background:"rgb(242 242 242)", color:"#000"}} onClick={() => handleHome()}>
          <span className="btn-inner--icon">
            <i className="fas fa-sign-in-alt" />
          </span>
          <span className="btn-inner--text"> Riaccedi a Teletabber con le tue credenziali SSO</span>
        </Button>


        <Button className="btnlo colMarginTop colMarginTop " style={{background:"rgb(242 242 242)", color:"#000"}} onClick={() => handleLogout()}>
          <span className="btn-inner--icon">
            <i className="fas fa-sign-out-alt" />
          </span>
          <span className="btn-inner--text"> Disconnetti il tuo utente in SSO</span>
        </Button>

      </div>


    </>
  );
};

export default observer(LogOutSSO);